import { useQuery } from '@tanstack/react-query'

import { accountLinkedAuthMethodsRetrieveOptions } from 'src/api/main/@tanstack/react-query.gen'

import type {
  LinkableAccountProvider,
  UseConnectedAccountsParams
} from './types'
import { useSocialAccountIntegration } from './useSocialAccountIntegration'
import { buildConnectedAccountsList } from './utils'

export const useConnectedAccounts = ({
  userEmail
}: UseConnectedAccountsParams) => {
  const linkedQuery = useQuery(accountLinkedAuthMethodsRetrieveOptions())
  const socialIntegration = useSocialAccountIntegration()
  const connectedAccounts = buildConnectedAccountsList(
    linkedQuery.data,
    userEmail
  )

  return {
    connectedAccounts,
    handleLinkApple: socialIntegration.handleLinkApple,
    handleLinkGoogle: socialIntegration.handleLinkGoogle,
    handleUnlinkProvider: socialIntegration.handleUnlinkProvider,
    hasError: linkedQuery.isError,
    isLinkingProvider: (provider: LinkableAccountProvider) =>
      socialIntegration.isLinkingProvider(provider),
    isLoading: linkedQuery.isLoading,
    isUnlinkPending: socialIntegration.isUnlinkPending,
    refetch: () => {
      void linkedQuery.refetch()
    }
  }
}
